// import React, { useState } from "react";
// import { NavLink } from "react-router-dom";
// import "./vednorApp.css";
// import triangle from "../../../assets/ecomm.png";
// import vendor1 from "../../../assets/vendorImg2.png";
// // import vendor2 from "../../../assets/moblies7.png";
// import vendor2 from "../../../assets/newImg/mobile2.png";
// import QRVendorPlay from "../../../assets/QR.jpeg";
// import QRCustomerPlay from "../../../assets/QR.jpeg";
// import QRVendorApp from "../../../assets/QR.jpeg";
// import QRCustomerApp from "../../../assets/QR.jpeg";
// import { LiaCheckCircleSolid } from "react-icons/lia";

// import { FaAndroid, FaApple } from "react-icons/fa";
// const VendorApp = () => {
//   const [activeStore, setActiveStore] = useState("googleplay");

//   // store badges
//   const googlePlayImg =
//     "https://hometriangle.com/images/svg/button-google-play.svg";
//   const appStoreImg = "https://hometriangle.com/images/svg/button-appstore.svg";
//   const toggleStore = () => {
//     setActiveStore((prev) =>
//       prev === "googleplay" ? "appstore" : "googleplay"
//     );
//   };
//   return (
//     <div className="container ">
//       <div className="row d-flex justify-content-around mt-xl-4 mt-lg-4 mt-md-2 mt-sm-2 mt-2  mb-1">
//         <div className="col-md-5  mt-xl-4 mt-lg-4 mt-md-2 mt-sm-2 my-2 mb-xl-3 mb-lg-3 mb-md-2 mb-sm-2 my-2">
//           <img src={vendor2} alt="" className="triangleImg" />
//         </div>

//         <div className="col-md-6 my-xl-5 my-lg-5 my-2">
//           <h3 className="triH1 joinCText my-xl-4 my-lg-4 my-md-2 my-sm-2 my-2">
//             Join our community
//             <span className="triH1Span"></span>
//           </h3>
//           <p className="triP joinCText my-xl-3 my-lg-2 my-md-2 my-2 ">
//             We have considered our business solutions to support you on every
//             stage of your growth.
//           </p>
//           <h3 className="triH3 text-center mt-3">
//             Choose your smartphone to download the{" "}
//             <span className="triAppspan">Mestry Circle</span> App.
//           </h3>

//           {/* <div className="toggleSwitch my-4" onClick={toggleStore}>
//             <div
//               className={`toggleKnob ${
//                 activeStore === "appstore" ? "right" : "left"
//               }`}
//             >
//               {activeStore === "googleplay" ? (
//                 <FaAndroid size={20} color="#3DDC84" />
//               ) : (
//                 <FaApple size={20} color="#000" />
//               )}
//             </div>

//             <div className="toggleLabels">
//               <span
//                 className={`toggleLabel ${
//                   activeStore === "googleplay" ? "active" : ""
//                 }`}
//               ></span>
//               <span
//                 className={`toggleLabel ${
//                   activeStore === "appstore" ? "active" : ""
//                 }`}
//               ></span>
//             </div>
//           </div>

//           <div className="text-center my-3">
//             <img
//               src={activeStore === "googleplay" ? googlePlayImg : appStoreImg}
//               alt="Store Logo"
//               className="triLogoImg"
//             />
//           </div>

//           <div className="d-flex justify-content-around gap-3 QRimg my-2">

//             <div className="text-center">
//               <p className="triH3 my-2">Vendor</p>
//               <div className="mobileFlex my-2">
//                 <img
//                   src={
//                     activeStore === "googleplay" ? QRVendorPlay : QRVendorApp
//                   }
//                   alt="Vendor QR"
//                   className="qrImage mt-2"
//                 />
//               </div>
//             </div>

//             <div className="text-center">
//               <p className="triH3 my-2">Customer</p>
//               <div className="mobileFlex my-2">
//                 <img
//                   src={
//                     activeStore === "googleplay"
//                       ? QRCustomerPlay
//                       : QRCustomerApp
//                   }
//                   alt="Customer QR"
//                   className="qrImage mt-2"
//                 />
//               </div>
//             </div>
//           </div> */}
//           <div className="row d-flex ">
//             {/* <div className="col-6 d-flex justify-content-center">
//               {" "}
//               <div
//                 className="toggleSwitch mt-xl-4 mt-lg-4 mt-md-3 mt-4 mb-xl-4 mb-lg-4 mb-md-2 mb-2"
//                 onClick={toggleStore}
//               >
//                 <div
//                   className={`toggleKnob ${
//                     activeStore === "appstore" ? "right" : "left"
//                   }`}
//                 >
//                   {activeStore === "googleplay" ? (
//                     <FaAndroid size={20} color="#3DDC84" />
//                   ) : (
//                     <FaApple size={20} color="#000" />
//                   )}
//                 </div>

//                 <div className="toggleLabels">
//                   <span
//                     className={`toggleLabel ${
//                       activeStore === "googleplay" ? "active" : ""
//                     }`}
//                   ></span>
//                   <span
//                     className={`toggleLabel ${
//                       activeStore === "appstore" ? "active" : ""
//                     }`}
//                   ></span>
//                 </div>
//               </div>
//             </div> */}
//             <div className="col-6 d-flex justify-content-center">
//               {" "}
//               <div
//                 className="toggleSwitch mt-xl-4 mt-lg-4 mt-md-3 mt-2 mb-0 "
//                 onClick={toggleStore}
//               >
//                 {/* mb-xl-1 mb-lg-1 mb-md-2 mb-2 */}
//                 <div
//                   className={`toggleKnob ${
//                     activeStore === "appstore" ? "right" : "right"
//                   }`}
//                 >
//                   {/* {activeStore === "googleplay" ? (
//                     <FaAndroid size={20} color="#3DDC84" />
//                   ) : (
//                     <FaApple size={20} color="#000" />
//                   )} */}
//                   {activeStore === "googleplay" ? (
//                     <>
//                       {" "}
//                       <FaApple size={20} color="#000" />
//                     </>
//                   ) : (
//                     <>
//                       {" "}
//                       <FaAndroid size={20} color="#3DDC84" />
//                     </>
//                   )}
//                 </div>

//                 {/* <div className="toggleLabels">
//                   <span
//                     className={`toggleLabel ${
//                       activeStore ===
//                       `googleplay   <p className="ms-3">switch to</p>`
//                         ? "active"
//                         : ""
//                     }`}
//                   ></span>

//                   <span
//                     className={`toggleLabel ${
//                       activeStore === "appstore" ? "active" : ""
//                     }`}
//                   ></span>
//                 </div> */}
//                 {/* <div className="toggleLabels">
//                   <span
//                     className={`toggleLabel ${
//                       activeStore === "googleplay" ? "active" : ""
//                     }`}
//                   >
//                     {activeStore === "googleplay" && (
//                       <p className="ms-4 mb-0">Switch to </p>
//                     )}
//                   </span>

//                   <span
//                     className={`toggleLabel ${
//                       activeStore === "appstore" ? "active" : ""
//                     }`}
//                   >
//                     {activeStore === "appstore" && (
//                       <p className="me-4 mb-0 ">Switch to </p>
//                     )}
//                   </span>
//                 </div> */}
//                 <div className="toggleLabels">
//                   <span
//                     className={`toggleLabel ${
//                       activeStore === "googleplay" ? "active" : ""
//                     }`}
//                   >
//                     {activeStore === "googleplay" && (
//                       <p className="me-1 mb-0  ">Switch to</p>
//                     )}
//                   </span>

//                   <span
//                     className={`toggleLabel ${
//                       activeStore === "appstore" ? "active" : ""
//                     }`}
//                   >
//                     {activeStore === "appstore" && (
//                       <p className="me-4 mb-0 ">Switch to </p>
//                     )}
//                   </span>
//                 </div>
//               </div>
//             </div>
//             <div className="col-6 ">
//               {" "}
//               <div className="text-center mt-xl-3 mt-lg-3 mt-md-2 mt-0 mb-2">
//                 <img
//                   src={
//                     activeStore === "googleplay" ? googlePlayImg : appStoreImg
//                   }
//                   alt="Store Logo"
//                   className="triLogoImg"
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Display active store logo */}

//           {/* QR Codes */}
//           <div className="d-flex justify-content-around gap-3 QRimg mb-xl-2 mb-lg-2 mb-md-2 mb-1">
//             {/* Vendor */}
//             <div className="text-center">
//               <p className="triH3 my-xl-2 my-lg-2 my-1">Vendor</p>
//               <div className="mobileFlex my-2">
//                 <img
//                   src={
//                     activeStore === "googleplay" ? QRVendorPlay : QRVendorApp
//                   }
//                   alt="Vendor QR"
//                   className="qrImage mt-2"
//                 />
//               </div>
//             </div>

//             {/* Customer */}
//             <div className="text-center">
//               <p className="triH3 my-xl-2 my-lg-2 my-1">Customer</p>
//               <div className="mobileFlex my-2">
//                 <img
//                   src={
//                     activeStore === "googleplay"
//                       ? QRCustomerPlay
//                       : QRCustomerApp
//                   }
//                   alt="Customer QR"
//                   className="qrImage mt-2"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default VendorApp;

import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./vednorApp.css";
import triangle from "../../../assets/ecomm.png";
import vendor1 from "../../../assets/vendorImg2.png";
// import vendor2 from "../../../assets/moblies7.png";
import vendor2 from "../../../assets/newImg/mobile2.png";
import QRVendorPlay from "../../../assets/QR.jpeg";
import QRCustomerPlay from "../../../assets/QR.jpeg";
import QRVendorApp from "../../../assets/QR.jpeg";
import QRCustomerApp from "../../../assets/QR.jpeg";
import { LiaCheckCircleSolid } from "react-icons/lia";

import { FaAndroid, FaApple } from "react-icons/fa";
const VendorApp = () => {
  const [activeStore, setActiveStore] = useState("googleplay");

  // store badges
  const googlePlayImg =
    "https://hometriangle.com/images/svg/button-google-play.svg";
  const appStoreImg = "https://hometriangle.com/images/svg/button-appstore.svg";
  const toggleStore = () => {
    setActiveStore((prev) =>
      prev === "googleplay" ? "appstore" : "googleplay"
    );
  };
  return (
    <div className="container ">
      <div className="row d-flex justify-content-around ">
        <div className="col-md-5  mobileDflex3  ">
          <img src={vendor2} alt="" className="triangleImg" />
        </div>

        <div className="col-md-6 ">
          <h3 className="triH1 joinCText my-xl-4 my-lg-4 my-md-3 my-sm-3 my-3">
            Join our community
            <span className="triH1Span"></span>
          </h3>
          <p className="triP joinCText my-xl-3 my-lg-2 my-md-2 my-2 ">
            We have considered our business solutions to support you on every
            stage of your growth.
          </p>
          <h3 className="triH3 text-center mt-3">
            Choose your QR code to download the{" "}
            <span className="triAppspan">Mestry Circle</span> App.
          </h3>

          <div className="col-12 my-xl-3 my-lg-3 my-md-2 my-sm-2 my-1">
            <div className="row">
              <div className="col-12">
                {" "}
                <p className="triHeading mt-xl-4 mt-lg-4 mt-2 mb-xl-3 mb-lg-3 mb-1  text-center">
                  Vendor
                </p>
              </div>
              <div className="col-6 d-flex justify-content-center">
                {" "}
                <div className=" my-xl-2 my-lg-2 my-1">
                  <img
                    src={QRCustomerPlay}
                    alt="Customer Play"
                    className="qrImage mt-2"
                  />
                  <div className="d-flex flex-column mt-xl-3 mt-lg-3 mt-md-2 mt-1">
                    <p className="triPara my-xl-2 my-lg-2 my-1 text-center">
                      App store
                    </p>
                    <img
                      src={appStoreImg}
                      alt="App Store"
                      className="triLogoImg my-1"
                    />
                  </div>
                </div>
              </div>
              <div className="col-6 d-flex justify-content-center">
                {" "}
                <div className=" my-xl-2 my-lg-2 my-1">
                  <img
                    src={QRCustomerApp}
                    alt="Customer App Store"
                    className="qrImage mt-2"
                  />
                  <div className="d-flex flex-column mt-xl-3 mt-lg-3 mt-md-2 mt-1">
                    <p className="triPara my-xl-2 my-lg-2 my-1 text-center">
                      Google play
                    </p>
                    <img
                      src={googlePlayImg}
                      alt="Google Play"
                      className="triLogoImg my-1"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                {" "}
                <p className="triHeading mt-xl-4 mt-lg-4 mt-2 mb-xl-3 mb-lg-3 mb-1 text-center">
                  Coustomer
                </p>
              </div>
              <div className="col-6 d-flex justify-content-center">
                {" "}
                <div className="my-xl-2 my-lg-2 my-1">
                  <img
                    src={QRCustomerPlay}
                    alt="Customer Play"
                    className="qrImage mt-2"
                  />
                  <div className="d-flex flex-column mt-xl-3 mt-lg-3 mt-md-2 mt-1">
                    <p className="triPara my-xl-2 my-lg-2 my-1 text-center">
                      App store
                    </p>
                    <img
                      src={appStoreImg}
                      alt="App Store"
                      className="triLogoImg my-1"
                    />
                  </div>
                </div>
              </div>
              <div className="col-6 d-flex justify-content-center">
                {" "}
                <div className=" my-xl-2 my-lg-2 my-1">
                  <img
                    src={QRCustomerApp}
                    alt="Customer App Store"
                    className="qrImage mt-2"
                  />
                  <div className="d-flex flex-column mt-xl-3 mt-lg-3 mt-md-2 mt-1">
                    <p className="triPara my-xl-2 my-lg-2 my-1 text-center">
                      Google play
                    </p>
                    <img
                      src={googlePlayImg}
                      alt="Google Play"
                      className="triLogoImg my-1"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorApp;
